import { config } from '../config';
import { downloadCSVFile, generateQueryString, isValidUUID, makeApiRequest_AppJson, makeApiRequest_blobData, makeApiRequest_formData, makeApiRequest_Text } from './common-apiService';

export const saveNewDashboard = async (accessToken, organizatonUUID, organizationdashboard) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/${organizatonUUID}/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, organizationdashboard);
}

export const updateDashboard = async (accessToken, organizatonUUID, organizationdashboard) => {
    // console.log('updateDashboard: ', organizationdashboard);
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/${organizatonUUID}/${organizationdashboard.dashboardId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, organizationdashboard);
}

export const deleteDashboard = async (accessToken, organizatonUUID, dashboardId) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/${organizatonUUID}/${dashboardId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const fetchAllDashboards = async (accessToken, organizatonUUID) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/${organizatonUUID}/`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchDashboard = async (accessToken, organizatonUUID, dashboardId) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/${organizatonUUID}/${dashboardId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchPublicDashboardInfo = async (organizatonUUID, dashboardId) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/public/${organizatonUUID}/${dashboardId}/info`;
    return makeApiRequest_AppJson(url, 'GET', {});
}

export const fetchPublicDashboard = async (organizatonUUID, dashboardId, password = null) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/public/${organizatonUUID}/${dashboardId}`;
    const headers = {};
    if (password) {
        headers['X-B2B-DASHBOARD-PASSW'] = password;
    }
    return makeApiRequest_Text(url, 'GET', headers);
}

export const fetchRelatedDashboards = async (accessToken, scope, dto) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/related-dashboards?scope=${scope}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, dto);
}

// WIDGETS

export const saveNewWidget = async (accessToken, organizatonUUID, dashboardId, widget) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/${organizatonUUID}/${dashboardId}/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, widget);
}

export const deleteWidget = async (accessToken, organizatonUUID, dashboardId, widgetId) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/${organizatonUUID}/${dashboardId}/${widgetId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

export const updateWidget = async (accessToken, organizatonUUID, dashboardId, widget) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/${organizatonUUID}/${dashboardId}/${widget.widgetId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, widget);
}

// WIDGET TEMPLATES

export const fetchAllWidgetTemplates = async (accessToken) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/widgets/templates`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchAvailableWidgetTemplates = async (accessToken, scope) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/widgets/templates/available?scope=${scope}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchWidgetTemplate = async (accessToken, widgetTemplateId) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/widgets/templates/${widgetTemplateId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const createWidgetTemplate = async (accessToken, widgetTemplateDTO) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/widgets/templates/new`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, widgetTemplateDTO);
}

export const updateWidgetTemplate = async (accessToken, widgetTemplateDTO) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/widgets/templates/${widgetTemplateDTO.id}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'PUT', headers, widgetTemplateDTO);
}

export const deleteWidgetTemplate = async (accessToken, widgetTemplateId) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/widgets/templates/${widgetTemplateId}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'DELETE', headers);
}

// WIDGET CONFIGS

export const fetchWidgetConfigs = async (accessToken, scope, dto) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/widgets/configs?scope=${scope}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, dto);
}

// WIDGET DATA

export const fetchWidgetData = async (accessToken, organizatonUUID, dashboardId, widgetId) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/${organizatonUUID}/${dashboardId}/${widgetId}/data`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
}

export const fetchWidgetPreviewData = async (accessToken, organizatonUUID, widget) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/${organizatonUUID}/dataPreview`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };
    return makeApiRequest_AppJson(url, 'POST', headers, widget);
}    

export const fetchWidgetPublicData = async (organizatonUUID, dashboardId, widgetId, password = null) => {
    const url = `${config.baseB2B_URL}/b2b/reporting/dashboard/public/${organizatonUUID}/${dashboardId}/${widgetId}/data`;
    const headers = {};
    if (password) {
        headers['X-B2B-DASHBOARD-PASSW'] = password;
    }
    return makeApiRequest_Text(url, 'GET', headers);
}

// PDF REPORTING

export const generatePdfReport = async (accessToken, pdfReportType, planUUID) => {
    let reportTypePath = 'standard';
    if (pdfReportType === 'report_aue') {
        reportTypePath = 'aue';
    } else if (pdfReportType === 'report_a2030') {
        reportTypePath = 'ma2030';
    }

    const url = `${config.baseB2B_URL}/b2b/reporting/${reportTypePath}/${planUUID}`;
    const headers = {
        'Authorization': `Bearer ${accessToken}`,
    };

    // Generate the file name based on the report type and current date and time
    const now = new Date();
    const formattedDate = now.toISOString().slice(2, 10).replace(/-/g, '');
    const formattedTime = now.toTimeString().slice(0, 5).replace(/:/g, '');
    const fileName = `back2blu_reporting_${reportTypePath}_${formattedDate}_${formattedTime}.pdf`;

    try {
        const blob = await makeApiRequest_blobData(url, 'GET', headers);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    } catch (error) {
        console.error('Error downloading pdf report:', error);
        throw new Error('Failed to download pdf report');
    }
}

// GIT

export const fetchGitReportingData = async () => {
    const url = `${config.baseB2B_URL}/b2b/reporting/git`;
    const headers = {
        'X-B2B-API-Key': config.gitAPIKey,
    };
    return makeApiRequest_AppJson(url, 'GET', headers);
};